/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubjectStepModel from 'cio/models/subject-step';

type SubjectStepDescriptionContentAttributeUpdateActionArgs = {
  step: SubjectStepModel;
};

export default class SubjectStepDescriptionContentAttributeUpdateAction extends Component<SubjectStepDescriptionContentAttributeUpdateActionArgs> {
  get personCreated() {
    let { status } = this.args.step;
    if (status == null) {
      // older subject steps do not have status
      return false;
    }
    return status.created && status.customerId != null;
  }

  get personId() {
    let { status, customerId } = this.args.step;

    // Older records or missing status data should not make links
    if (status == null) {
      return null;
    }

    if (status.customerId != null) {
      return status.customerId;
    }

    if (!status.isInternalIdentifier) {
      return null;
    }

    return customerId;
  }

  get personMerged() {
    let { status } = this.args.step;

    if (status?.customerId == null) {
      return false;
    }
    return status?.merged;
  }

  get someoneElseUpdated() {
    let { status } = this.args.step;
    if (status?.attributeUpdate == null || this.personCreated) {
      return false;
    }
    return status.customerId != null && status.attributeUpdate.updatedCount > 0;
  }

  get attributesUpdateSuccess() {
    let { status } = this.args.step;

    if (status?.attributeUpdate == null) {
      // older subject steps do not have status
      return false;
    }

    return !status.attributeUpdate.hasFailures;
  }

  get attributesUpdateFailed() {
    let { status } = this.args.step;

    if (status?.attributeUpdate == null) {
      // older subject steps do not have status
      return false;
    }
    // XXX: we might have partial failure, not sure how to show that
    return status.attributeUpdate.hasFailures;
  }

  get attributesUpdateSkipped() {
    let { status } = this.args.step;

    if (status?.attributeUpdate == null) {
      // older subject steps do not have status
      return false;
    }

    return status.attributeUpdate.updatedCount === 0 && !status.attributeUpdate.hasFailures;
  }
}
